"use client"

import { type LucideIcon } from "lucide-react"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  } from "@/components/ui/sidebar"
  import { Link } from "react-router-dom"

type Project = {
  name: string
  url: string
  icon: LucideIcon
}

type NavProjectsProps = {
  projects: Project[]
}

export function NavProjects({ projects }: NavProjectsProps) {

  if (projects.length === 0) {
    return null
  }

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Projects</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {projects.map((project) => (
            <SidebarMenuItem key={project.name}>
                <Link to={project.url} className="flex items-center gap-2">
                  <project.icon />
                  <span>{project.name}</span>
                </Link>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}

